import { action, computed, observable } from 'mobx';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { SurveySubmissionApis } from '../../../apis/surveySubmissions';
import { SurveyState } from './SurveyState';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { translateErrorMessage } from "../../../../commonv3/api/protocol";
import { SurveyKeys } from "../../../../commonv3/types/surveys";
import { EventReservationApis } from "../../../apis/eventReservations";

export class ReservationCancelSurveyPageState {
    @observable submitState = new SubmitState();
    @observable routerState = GlobalStatesV3.routing;
    @observable success = false;
    @observable reservationId;
    surveyState = new SurveyState();
    surveyKey = SurveyKeys.TRIAL_LESSON_RESERVATION_CANCEL;


    @action.bound
    async init() {
        await this.surveyState.init(this.surveyKey);
    }

    @computed
    get hasSurvey(): boolean {
        return !this.surveyState.survey.isEmpty() && !this.surveyState.parameterParseError;
    }

    // TODO: submit の内容は別 PR で対応します。
    @action.bound
    async submit() {
        try {
            await this.surveyState.validate();
            if (!this.surveyState.hasErrors) {
                const surveyKey = this.surveyState.hasSurvey ? this.surveyState.surveyKey : null;
                this.submitState.operate(async () => {
                    const survey_submission = await SurveySubmissionApis.create(
                        surveyKey,
                        this.surveyState.parameters,
                        this.surveyState.questionAnswers,
                    );
                    await EventReservationApis.cancel(
                        this.reservationId,
                        {
                            'cancel_survey_submission_id': survey_submission.id
                        }

                );
                    this.success = true;
                    GlobalStatesV3.routing.push(V3Routes.reservationCancelComplete());
                });
            }
        } catch (e) {
            alert('予約のキャンセルに失敗しました: ' + translateErrorMessage(e));
        }
    }
}
